import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-bootstrap/Pagination';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { InputGroup, FormControl } from 'react-bootstrap';
import { toast } from 'react-toastify';
import AppNavbar from "./AppNavbar";

const API_BASE = 'https://hospital.rozeetechnist.com/hospital-api';

const ContributionList = () => {
    const navigate = useNavigate();
    const [list, setList] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [searchTerms, setSearchTerms] = useState("");

    useEffect(() => {
        if (!localStorage.getItem('login')) navigate('/login');
    }, [navigate]);

    useEffect(() => { getData(); }, [currentPage, searchTerms]);

    const getData = () => {
        fetch(API_BASE + '/getContributions.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ start: currentPage, per_page: itemsPerPage, search: searchTerms || '' })
        })
            .then(res => res.json())
            .then(result => {
                setTotalItems(result.total_records || 0);
                setList(result.data || []);
            })
            .catch(() => toast.error('Failed to load contributions'));
    };

    const deleteItem = (id) => {
        if (!window.confirm('Delete this contribution?')) return;
        let deletedBy = null;
        try {
            const login = localStorage.getItem('login');
            if (login) deletedBy = JSON.parse(login).id;
        } catch (_) {
            // ignore parse error
        }
        fetch(API_BASE + '/deleteContribution.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, deleted_by: deletedBy })
        })
            .then(res => res.json())
            .then(resp => {
                if (resp.status) { getData(); toast.success(resp.message); }
                else toast.error(resp.message);
            })
            .catch(() => toast.error('Failed to delete'));
    };

    const totalPages = Math.ceil(totalItems / itemsPerPage) || 1;
    const getPaginationItems = () => {
        const items = [];
        let s = Math.max(1, currentPage - 2), e = Math.min(totalPages, currentPage + 2);
        for (let i = s; i <= e; i++)
            items.push(<Pagination.Item key={i} active={i === currentPage} onClick={() => setCurrentPage(i)}>{i}</Pagination.Item>);
        return items;
    };

    return (
        <div>
            <AppNavbar />
            <section className="wrapper">
                <div className="container">
                    <div className="row top-page-bar">
                        <div className="col-md-4"><div className="main-title"><h1>Contribution</h1></div></div>
                        <div className="col-md-8">
                            <div className="search-area">
                                <InputGroup>
                                    <FormControl placeholder="Search" value={searchTerms} onChange={e => setSearchTerms(e.target.value)} />
                                </InputGroup>
                            </div>
                        </div>
                    </div>
                </div>
                <main className="container">
                    {list && list.length > 0 ? (
                        <>
                            <Table striped bordered hover responsive>
                                <thead><tr><th>Title</th><th>Amount</th><th>Description</th><th>Status</th><th>Action</th></tr></thead>
                                <tbody>
                                    {list.map(item => (
                                        <tr key={item.id}>
                                            <td>{item.title}</td>
                                            <td>{item.amount}</td>
                                            <td>{item.description || '-'}</td>
                                            <td>{item.status}</td>
                                            <td>
                                                <Link to={'/contribution-update/' + item.id}><FontAwesomeIcon icon={faEdit} color="green" /></Link>
                                                <span style={{ marginLeft: 10, cursor: 'pointer' }} onClick={() => deleteItem(item.id)}><FontAwesomeIcon icon={faTrash} color="red" /></span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <Pagination>
                                <Pagination.Prev onClick={() => setCurrentPage(p => p - 1)} disabled={currentPage === 1} />
                                {getPaginationItems()}
                                <Pagination.Next onClick={() => setCurrentPage(p => p + 1)} disabled={currentPage >= totalPages} />
                            </Pagination>
                            <div className="createButton"><Link to="/contribution-create"><FontAwesomeIcon icon={faPlus} /></Link></div>
                        </>
                    ) : (
                        <>
                            <p>No contributions found</p>
                            <div className="createButton"><Link to="/contribution-create"><FontAwesomeIcon icon={faPlus} /></Link></div>
                        </>
                    )}
                </main>
            </section>
        </div>
    );
};

export default ContributionList;
